import { LocalDate, LocalTime, ZonedTime, DateRange } from './types';
import { startOfHour } from './dateHelpers';

// No nulo solo mientras el último día de A está en curso. Alinea A y B a la
// misma hora de reloj para que "hoy hasta ahora" no se compare contra un día
// completo — ver §05.
const resolveCutoff = (a: DateRange, today: LocalDate, now: ZonedTime): LocalTime | null => {
  if(a.end !== today) {
    return null;
  }
  return startOfHour(now);
};

export { resolveCutoff };
